import { useState } from 'react';
import {
  CROA_COMPLIANT,
  reportOptimizely,
} from 'externals/_tracking/optimizely';
import { useVariationForExperiment } from 'externals/_tracking/optimizely/optimizely.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { isPremium } from 'helpers/userHelper';
import { getDaysSinceWithNull } from 'helpers/dateHelper';
import { SUBSCRIPTION_VERTICAL } from 'types/mrph.vertical.constants';
import { hasFreeTrialBeenUsedBefore } from 'helpers/userHelper';

export const useCROABanner = (userInfo, creditInfo, history, eventHandler) => {
  const [isSeenTriggered, setIsSeenTriggered] = useState(false);
  const expCROABanner = useVariationForExperiment(CROA_COMPLIANT);
  const isPremiumUser = isPremium(userInfo);
  const { variation } = expCROABanner;

  const displayClasses = `${variation ? variation : ''}`;
  const showCROABanner =
    !isPremiumUser && !hasFreeTrialBeenUsedBefore(userInfo);
  const daysLastSignedIn =
    userInfo?.previousLoginDate &&
    getDaysSinceWithNull(userInfo?.previousLoginDate);
  const loggedInCount = userInfo?.loggedInCount;
  const creditScore = creditInfo?.creditScore;
  const userSegment = userInfo?.userSegmentationNumber;
  const previousPage = history?.location?.pathname;

  const handleTurboCROACTAClick = e => {
    e.preventDefault();
    eventHandler(CLICK, {
      'Click Type': `Premium Banner CTA`,
      'Page Position': 'Premium',
      'Plan Type': 'CROA Turbo',
      'Product Offer': 'CROA Turbo',
      'Days Last Signed In': daysLastSignedIn,
      'Logged In Count': loggedInCount,
      'Credit Score': creditScore,
      'User Segment': userSegment,
      'Referral Page (Previous Page)': previousPage,
      Vertical: SUBSCRIPTION_VERTICAL,
    });
    reportOptimizely('premiumUpsellCTAClick');
    history.push('/premium/V2');
  };

  const onVisibilityChange = isVisible => {
    if (isVisible === true && !isSeenTriggered) {
      setIsSeenTriggered(true);
    }
  };

  return {
    experiment: expCROABanner,
    showCROABanner,
    onVisibilityChange,
    displayClasses,
    variation,
    history,
    handleTurboCROACTAClick,
  };
};
